import {useSelector} from "react-redux";

export default function () {
    const submitVoteInit = useSelector(state => state.vote.init);
    const submitVoteLoading = useSelector(state => state.vote.loading);
    return { submitVoteInit, submitVoteLoading };
}